import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import './index.css'
import HomeContextProvider from 'Contexts/HomeContextProvider.tsx';
import ThemeContextProvider from 'Contexts/ThemeContextProvider.tsx';
import { startVersionCheck } from 'helpers/VersionHelper';

startVersionCheck()

const CustLoader = React.lazy(() => import("components/CustLoader/CustLoader"))
const App = React.lazy(() => import("./App.tsx"))
createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <BrowserRouter>
      <ThemeContextProvider>
        <HomeContextProvider>
          <Suspense fallback={<CustLoader />}><App /></Suspense>
        </HomeContextProvider>
      </ThemeContextProvider>
    </BrowserRouter>
  // {/* </StrictMode>, */}
)
